import { ActionContributionsService } from '@ansys-internal/awf-angular/contributions';
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject,
  Input,
  Output,
  Type,
} from '@angular/core';
import {
  BlobFilesApiService,
  LibraryObject,
} from '@ansys/cloud-angular-client';
import {
  LIBRARY_RESOURCE_DATA,
  LibraryResourceData,
  LibraryService,
  Sections,
} from '@ansys-internal/awf-angular/dashboard';
import { LibraryService as LibraryAPIService } from '../../../../api/services/LibraryService';
import { SnackBarService } from '@ansys-internal/awf-angular/shared';
import { State } from '@ansys-internal/awf-angular/store';
import {
  ButtonType,
  ButtonSize,
  ButtonComponent,
} from '@ansys-internal/awc-angular/buttons';
import { IconType, Icons } from '@ansys-internal/awc-angular/icons';
import { ComponentInDB, ConfigurationInDB } from 'src/api';
import { EventBus } from 'src/app/shared/tools/event-bus';
import {
  SectionSelectAction,
  ActiveSectionState,
} from '@ansys-internal/awf-angular/workspace';
import { lastValueFrom } from 'rxjs';
import { ActiveConceptState } from '../../../state/lib/active-concept.state';
import { ConceptService } from '../../../shared/services/concept.service';
import { PartInputsComponent } from '../part-inputs/part-inputs.component';

@Component({
    selector: 'app-library-panel',
    templateUrl: './library-panel.component.html',
    styleUrls: ['./library-panel.component.scss'],
    imports: [ButtonComponent, PartInputsComponent]
})
export class LibraryPanelComponent {
  @Input() resourceId!: string;
  @Output() resourceLoaded = new EventEmitter<void>();
  protected libraryObject!: LibraryObject | Promise<Record<string, any>>;
  protected resource!: Type<ConfigurationInDB | ComponentInDB>;
  protected parentType!: string;
  protected type: ButtonType = ButtonType.PRIMARY;
  protected size: ButtonSize = ButtonSize.MEDIUM;
  protected suffixIcon: IconType = { icon: Icons.SUCCESS };
  private bus = EventBus.getInstance();

  constructor(
    @Inject(LIBRARY_RESOURCE_DATA) public data: LibraryResourceData,
    private libraryService: LibraryService,
    private libraryAPIService: LibraryAPIService,
    private blobFile: BlobFilesApiService,
    private snackbar: SnackBarService,
    private actions: ActionContributionsService,
    private state: State,
    private _cdr: ChangeDetectorRef,
    private conceptService: ConceptService
  ) {}

  async ngOnInit(): Promise<void> {
    if (this.resourceId) {
      const concept = this.state.value(ActiveConceptState);
      if (concept) {
        this.libraryObject = lastValueFrom(
          this.libraryAPIService.getFromLibraryLibraryObjectIdGet(
            this.resourceId,
            concept.design_instance_id as string
          )
        );

        this.libraryObject.then(async (libObject) => {
          this.resource = libObject as Type<ConfigurationInDB | ComponentInDB>;

          this.parentType = (this.resource as ConfigurationInDB)
            .config_type as string;

          if (
            !this.parentType &&
            (this.resource as ComponentInDB).component_type
          ) {
            this.parentType = this.conceptService.typeMap.get(
              (this.resource as ComponentInDB).component_type as string
            ) as string;
          }

          this._cdr.detectChanges();
          this.resourceLoaded.emit();
        });
      }
    } else {
      this.data?.file?.text().then((content: string) => {
        const parsedData = JSON.parse(content);
        this.resource = parsedData;
        this.parentType = parsedData._parentID;
        this._cdr.detectChanges();
        this.resourceLoaded.emit();
      });
    }
  }

  protected cancelEdit(): void {
    this.libraryService.setEditable(false);
  }
}
